function validation(paint) {
    let errors = {}

    // title
    if (!paint.title) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (!paint.title.trim()) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (paint.title.length > 90) {
        errors.title = 'طول تیتر نباید بیشتر از 90 کارکتر باشد.'
    } else {
        delete errors.title
    }
    // image
    if (!paint.images.length) {
        errors.images = 'لطفا عکس گوشه را وارد کنید.'
    } else {
        delete errors.images
    }
    //full_frame
    if (!paint.full_frame.length) {
        errors.full_frame = 'لطفا عکس مربع را وارد کنید.'
    } else {
        delete errors.full_frame
    }
    //horizontal_frame
    if (!paint.horizontal_frame.length) {
        errors.horizontal_frame = 'لطفا عکس افقی را وارد کنید.'
    } else {
        delete errors.horizontal_frame
    }
    //vertical_frame
    if (!paint.vertical_frame.length) {
        errors.vertical_frame = 'لطفا عکس عمودی را وارد کنید.'
    } else {
        delete errors.vertical_frame
    }

    // width
    if (!paint.width) {
        errors.width = 'عرض قاب را وارد کنید.'
    } else if (paint.width < 1) {
        errors.width = 'عرض قاب را به درستی وارد کنید.'
    } else {
        delete errors.width
    }
    // pixel_width
    if (!paint.pixel_width) {
        errors.pixel_width = 'پیکسلیت قاب را وارد کنید.'
    } else if (paint.pixel_width < 1) {
        errors.pixel_width = 'پیکسلیت قاب را به درستی وارد کنید.'
    } else {
        delete errors.pixel_width
    }

    // price
    if (!paint.price) {
        errors.price = 'قیمت قاب را وارد کنید.'
    } else if (paint.price < 1) {
        errors.price = 'قیمت قاب را به درستی وارد کنید.'
    } else {
        delete errors.price
    }
    // body
    if (paint.body.length < 200) {
        errors.body = "طول توضیحات باید بیش از 200 کارکتر باشد"
    } else {
        delete errors.body
    }

    return errors
}
export default validation;